import React from 'react';
import { X } from 'lucide-react';
import SeatSelectionWidget from './SeatSelectionWidget';


/**
 * Modal wrapper for SeatSelectionWidget.
 * Handles opening/closing logic and layout.
 */
const SeatSelectionModal = ({
  isOpen,
  onClose,
  event,
  ticketType,
  onConfirmSelection, // New confirmation handler
  publicKey
}) => {
  if (!isOpen) return null;

  return (
    <div className="seat-modal-overlay">
      <div className="seat-modal-content">
        <button
          onClick={onClose}
          className="seat-modal-close-btn"
          aria-label="Close Seat Selection"
        >
          <X size={24} />
        </button>

        <div className="seat-modal-body">
          <SeatSelectionWidget
            event={event}
            ticketType={ticketType}
            publicKey={publicKey}
            onConfirmSelection={onConfirmSelection}
          />
        </div>
      </div>

      <style>{`
                .seat-modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.85);
                    backdrop-filter: blur(8px);
                    z-index: 1000;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    animation: fadeIn 0.3s ease-out;
                }

                .seat-modal-content {
                    background: #1c1c1e;
                    border: 1px solid rgba(255, 215, 0, 0.2);
                    border-radius: 20px;
                    width: 95vw;
                    max-width: none;
                    height: 95vh;
                    max-height: none;
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
                    overflow: hidden;
                    animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
                }

                .seat-modal-close-btn {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    background: rgba(255, 255, 255, 0.1);
                    border: none;
                    color: white;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    z-index: 10;
                    transition: all 0.2s ease;
                }

                .seat-modal-close-btn:hover {
                    background: rgba(235, 75, 75, 0.2);
                    color: #ff3b30;
                    transform: rotate(90deg);
                }

                .seat-modal-body {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                    /* Clean scrollbar */
                    scrollbar-width: thin;
                    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
                }
                
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideUp {
                    from { transform: translateY(20px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
            `}</style>
    </div>
  );
};

export default SeatSelectionModal;
